import { render, staticRenderFns } from "./CampaignMusic.vue?vue&type=template&id=57bff7ba&"
import script from "./CampaignMusic.vue?vue&type=script&lang=ts&"
export * from "./CampaignMusic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports